<template>
  <header class="header column is-12">
    <div
      class="navbar container"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand">
        <router-link
          :to="{ path: '/' + activeLanguage + '/' }"
          :title="name"
          class="navbar-item"
          @click.native="$store.dispatch('toggleNavbar', 'close')"
        >
          <img :src="logo" :alt="name" />
        </router-link>
        <a
          role="button"
          class="navbar-burger burger"
          :class="activeClass"
          aria-label="menu"
          aria-expanded="false"
          data-target="via-navbar"
          @click.prevent="$store.dispatch('toggleNavbar')"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div id="via-navbar" class="navbar-menu" :class="activeClass">
        <div class="navbar-start"></div>
        <div class="navbar-end">
          <router-link
            v-for="(page, idx) in pages"
            v-bind:key="idx"
            :to="{ path: '/' + activeLanguage + '/' + page.ID }"
            class="navbar-item"
            @click.native="$store.dispatch('toggleNavbar', 'close')"
            :class="{ 'is-active': activePage.ID === page.ID }"
          >
            <span>{{
              page.Cultures[activeLanguage].Meta.Name === ""
                ? page.Cultures[activeLanguage].Meta.ID
                : page.Cultures[activeLanguage].Meta.Name
            }}</span>
          </router-link>
          <div class="navbar-item">
            <!-- <a
              href="#"
              v-for="(culture, key) in cultures"
              :key="key"
              class="lang"
              :class="{ 'not-in-start has-tooltip-bottom': !culture.inStart }"
              :data-tooltip="
                !culture.inStart ? $resx('General.NotInStart') : undefined
              "
              :title="culture.inStart ? culture.text : undefined"
              @click.prevent="
                $store.dispatch('toggleNavbar', 'close'),
                  $store.dispatch('setLanguage', key)
              "
            >
              <span
                :class="[
                  { active: activeLanguage === key },
                  'flag flag-xs flag-' + key.split('-')[1].toLowerCase(),
                ]"
              ></span>
            </a> -->
            <div class="dropdown is-right is-hoverable">
              <div class="dropdown-trigger">
                <span class="icon-text">
                  <span class="icon"
                    ><font-awesome-icon :icon="icons.culture" fixed-width
                  /></span>
                  <span>{{ activeLanguageName }}</span>
                </span>
              </div>
              <div class="dropdown-menu" id="dropdown-menu6" role="menu">
                <div class="dropdown-content">
                  <a
                    href="#"
                    class="dropdown-item"
                    v-for="(culture, key) in cultures"
                    :key="key"
                    :class="{'is-active': activeLanguage === key}"
                    @click.prevent="
                      $store.dispatch('toggleNavbar', 'close'),
                        $store.dispatch('setLanguage', key)
                    "
                  >
                    <small>{{ culture.text }}</small>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="navbar-item software" v-if="hasLogin">
            <a
              class="button"
              :class="{ 'go-back': me }"
              :href="softwareLoginDomain"
              target="_self"
            >
              <img v-if="me" :src="me.Avatar" />
              <span class="icon" v-else>
                <font-awesome-icon :icon="icons.lock" />
              </span>
              <span
                ><strong>{{
                  $t("Buttons." + (me ? "GoBack" : "Login"))
                }}</strong></span
              >
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { faLock } from '@fortawesome/pro-solid-svg-icons'
import { faLanguage } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'mainMenu',
  components: {},
  data: function () {
    return {
      org: process.env.VUE_APP_NAME,
      logo: '/img/logo.png',
      icons: {
        lock: faLock,
        culture: faLanguage
      },
      hasLogin: process.env.VUE_APP_LOGIN === 'true'
    }
  },
  computed: {
    softwareLoginDomain () {
      // console.log(VUE_APP_DOMAIN);
      return this.$store.state.domain + (this.me ? '' : 'login')
    },
    me () {
      var self = this
      var me = self.$auth.via_me().get()
      if (me.Fullname && me.Avatar) {
        return me
      } else {
        return false
      }
    },
    name () {
      return this.org.toUpperCase()
    },
    homepage () {
      var self = this
      if (self.$store.state.sitemap && self.$store.state.sitemap.length > 0) {
        return self.$store.state.sitemap.filter(function (value) {
          return (
            value.ID.toLowerCase() === self.$store.state.homepage.toLowerCase()
          )
        })
      } else {
        return [{}]
      }
    },
    pages () {
      var self = this
      if (self.$store.state.sitemap && self.$store.state.sitemap.length > 0) {
        return self.$store.state.sitemap.filter(function (value) {
          return (
            value.InMain && value.Cultures.hasOwnProperty(self.activeLanguage)
          )
        })
      } else {
        return []
      }
    },
    cultures () {
      var cultures = {}
      for (var key in this.$store.state.cultures) {
        var inStart =
          this.homepage[0].Cultures &&
          this.homepage[0].Cultures.hasOwnProperty(key)
        if (inStart || this.$store.state.isAdmin) {
          cultures[key] = {
            text: this.$store.state.cultures[key],
            inStart: inStart
          }
        }
      }
      return cultures
    },
    activeLanguage () {
      return this.$store.state.language
    },
    activeLanguageName () {
      var key = Object.keys(this.cultures).find(
        (c) => c === this.activeLanguage
      )
      return this.cultures[key].text.replace(/\s\(([a-z]|\s)+\)/ig, '')
    },
    activePage () {
      return this.$store.state.activePage
    },
    activeClass () {
      return this.$store.state.navbarActive ? 'is-active' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes navAnim {
  0% {
    display: none;
    opacity: 0;
  }
  1% {
    display: block;
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.header {
  width: 100%;
  background: $white;
  border-bottom: 10px solid $primary;
  z-index: 10;

  .navbar {
    padding-top: 0.75rem;
    @include setDecoration;
    overflow: visible;

    .navbar-brand {
      img {
        border: 0;
        vertical-align: middle;
        height: 4.5rem;
        width: auto;
      }
      .navbar-burger {
        width: 4.5rem;
        height: 4.5rem;
        &:hover {
          background-color: transparent;
        }
      }
    }
    .navbar-item {
      text-transform: uppercase;
      font-weight: 700;
      padding: 0.5rem 1.5rem;

      &.is-active {
        color: $navbar-item-active-color;
      }

      .icon-text{
        >.icon{
          vertical-align: bottom;
          margin-right: 4px;
        }
      }

      // .lang {
      //   line-height: 1;
      //   + .lang {
      //     margin-left: 10px;
      //   }
      //   span {
      //     opacity: 0.4;
      //     filter: alpha(opacity=40);
      //     &.active,
      //     &.active:hover {
      //       opacity: 1;
      //       filter: alpha(opacity=100);
      //     }
      //   }
      //   &.not-in-start {
      //     border: 1px solid $danger;
      //   }
      // }
      &.software {
        .button {
          background-color: $grey-lightest;
          border: none;
          color: $grey-light;
          position: relative;
          padding: 8px 18px 8px 18px;
          &.go-back {
            padding-left: 40px;
          }
          height: auto;
          // margin-left: 20px;
          &:hover {
            background-color: $grey-lighter;
          }
          img {
            height: 22px;
            position: absolute;
            left: 8px;
          }
          span {
            line-height: 22px;
            font-size: 12px;
          }
        }
      }
    }

    @media screen and (max-width: $bp-desktop - 1px) {
      .navbar-menu {
        position: absolute;
        width: 100%;

        &.is-active {
          animation: navAnim 0.2s ease-in-out;
        }
        .navbar-item {
          &.software {
            .button {
              margin-left: 0px;
            }
          }

          .dropdown{
            .dropdown-menu{
              left: 0;
              right: auto;
            }
          }
        }
      }
    }
  }
}
</style>
